export default __webpack_public_path__ + "static/media/carlLoryIndoorMb2.d1155632.png";